import { Component, computed, input } from '@angular/core';
import { Business, getFullAddress, License } from 'src/model/business';
import { Customer } from 'src/model/customer.model';

@Component({
    selector: 'app-formj-receipt-letter',
    templateUrl: './formj-receipt-letter.component.html',
    styleUrls: ['./formj-receipt-letter.component.scss'],
    standalone: false
})
export class FormjReceiptLetterComponent {
  selectedBusiness = input.required<Business>();
  selectedBusinessLicense = input.required<License>();
  selectedCustomer = input.required<Customer>();

  fullAddress = computed<string>(() => getFullAddress(this.selectedBusinessLicense().Address));
}
